import BackArrow from "./Icon/BackArrow";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import { ReactNode } from "react";

function BreadCrumb({ showBack, onPressBack, label, right }: { showBack?: boolean, onPressBack?: () => void, label: string, right?: ReactNode }) {
  const navigate = useNavigate()
  return (
    <div className="flex w-full items-center justify-between mb-6"><div className="flex items-center ">
      {
        showBack &&
        <Button variant="ghost" size="icon" className="cursor-pointer bg-transparent mr-2" onClick={() => onPressBack ? onPressBack?.() : navigate(-1)}>
          <BackArrow />
        </Button>
      }
      <h1 className="text-xl font-medium text-primary">
        {label}
      </h1>
    </div>
      {right}
    </div>
  );
}

export default BreadCrumb;